//this page will be hidden and not available on the navigation bar
// to access it just type the url /menus/{the resturant we r displaying};

import { MenuPageStyled} from "../styles";
import { sekCategories } from "../data/foodMenuCategories";
import { BowlsGrid, PlatesGrid, SandwichesGrid, DipsGrid, AddOnsGrid, DrinksGrid, AppetizersGrid, CombosGrid, SaladsGrid } from "../components/MenuGrids/sekMenu";
import {useEffect, useState} from "react";
import $ from 'jquery';
import styled from "styled-components";
import {LoadingIcon} from "../components";
import axios from "axios";

function FoodMenu() {

    const [menuItems, setMenuItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const url = process.env.NODE_ENV == "development" ? process.env.REACT_APP_API_URL_DEV : process.env.REACT_APP_API_URL_PROD;


    async function getAllItems() {
        try {
            const link = `${url}/sek`;
            const {data: {items}} = await axios.get(link, {});
           

            const categories = {
                "COMBOS": [],
                "SANDWICHES": [],
                "PLATES": [],
                "DIPS": [],
                "ADD ONS": [],
                "APPETIZERS": [],
                "DRINKS": [],
            }
     
            items.forEach(item => {
                if(item.category && categories[item.category]) {
                    categories[item.category].push(item);
                }
            })
            setMenuItems(categories)
            setLoading(false);
        } catch (error) {
            console.log("the error recieved is: ", error.message);
        }
    }

    useEffect(() => {
        getAllItems();
    }, []);

    useEffect(() => {
        
        if(!loading) {
            const sections = document.querySelectorAll("section");
            const navLi = document.querySelectorAll("nav .foodNavBar ul li");
           
            var navBar = $('.foodNavBar').offset().top;
            
    
            //uncomment navbar stuff if manager wants old styling
            const handleScroll = event => {
                console.log("trig")
                var currentScroll = window.pageYOffset;
                console.log("current scroll is: ", currentScroll);
                console.log("nav bar is : ", navBar);
      
                
                var current = "";
                sections.forEach((section) => {
                    const sectionTop = section.offsetTop; //how far the section is from top
                    if (window.pageYOffset  >= sectionTop - 60) {
                        current = section.getAttribute("id");
                    }
                });
        
                navLi.forEach((li) => {
                    li.classList.remove("active");
                    if(li.classList.contains(current)) {
                        li.classList.add("active");
                    }
                });
            }
    
            window.addEventListener('scroll', handleScroll);
    
            return () => {
                window.removeEventListener('scroll', handleScroll);
            }
        }
    }, [loading])

 

    if(loading) {
        return (
            <LoadingIcon/>
        )
    }
    
    return (
        <>
         <MenuPageStyled>
                    <nav>
                        <div className = "foodNavBar">
                            <ul>
                                {
                                    sekCategories.map(({refNo, category, className}) => {
                                        return (
                                            <>
                                            <li class = {className}>
                                                <a href = {refNo} style = {{fontFamily: "Akizdenz-Grotesk BQ"}}>
                                                    {category}
                                                </a>
                                            </li>
                                        </>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                    </nav>
            <Test>
            </Test>
                
                    <section id = "category_8">
                        <CombosGrid categoryItems = {menuItems["COMBOS"]}/>
                    </section>
                    <section id = "category_1">
                        <SandwichesGrid categoryItems = {menuItems["SANDWICHES"]}/>
                    </section>
                 
                    <section id = "category_3">
                        <PlatesGrid categoryItems = {menuItems["PLATES"]}/>
                    </section>
                    <section id = "category_4">
                        <DipsGrid categoryItems = {menuItems["DIPS"]}/>
                    </section>
                    <section id = "category_5">
                        <AddOnsGrid categoryItems = {menuItems["ADD ONS"]}/>
                    </section>
               
                    <section id = "category_7">
                        <AppetizersGrid categoryItems = {menuItems["APPETIZERS"]}/>
                    </section>
                    <section id = "category_9">
                        <DrinksGrid categoryItems = {menuItems["DRINKS"]}/>
                    </section>
                    <CopyRightStyled>
                        <a href = "https://www.lovelysunnyday.com/home" target = "_blank" style = {{position: "absolute" , inset: "0",  width: "100%" , display: "flex", justifyContent: "center"}}>
                            <img src = "/Developed-By-LSD.svg"/>
                        </a>
                    </CopyRightStyled>
                </MenuPageStyled>
    </>
    )
    
}

const Test = styled.div`
    position: relative;
    img {
        margin-top: 15px;
        width:100%;
    }

   
`
const CopyRightStyled = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    padding: 40px 0px;
    width: 100%;
    img {
        width: 60%;
    }
`

export default FoodMenu;